import {ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {byId, crudifyMutations, hydrateEdit, resetResults, savePayload} from 'src/utilities/vuex2'
import Vue from 'vue'
import _ from 'lodash'
import {OK} from 'http-status-codes'
import {maybeAppendInactive} from '@/utilities/utils'

const initialState = {
  edit: {
    id: null,
    name: null,
    cities: [],
    active: true
  },
  results: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
getters.byId = byId
getters.savePayload = savePayload

const mutations = make.mutations(state)
mutations.resetResults = resetResults
mutations.hydrateEdit = hydrateEdit
crudifyMutations(mutations)

mutations.resetEdit = (state) => {
  state.edit = JSON.parse(JSON.stringify(initialState.edit))
}

mutations.addCity = (state, city) => {
  if (!state.edit.cities.includes(city)) {
    state.edit.cities.push(city)
    state.edit.cities.sort()
  }
}

mutations.deleteCity = (state, cityToDelete) => {
  state.edit.cities = _.filter(state.edit.cities, (city) => city !== cityToDelete)
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchByNameStartsWith({ state }, payload) {
      if (payload.name) {
        payload.query = payload.name
      }

      const url = `streets/search/findByNameStartsWithIgnoreCaseAndActiveOrderByNameAsc?name=${encodeURIComponent(payload.query)}&active=${payload.active}`
      const response = await ptracGetEntities(url)

      if (OK === response.status) {
        state.results = response.data
      }

      return response
    },
    async fetchByNameStartsWithForResultsModal({ state }, name) {
      const url = `streets/search/findByNameStartsWithIgnoreCaseOrderByNameAsc?name=${encodeURIComponent(name)}`
      const response = await ptracGetEntities(url)

      if (OK === response.status) {
        state.results = maybeAppendInactive(response.data)
      }

      return response
    },
    async fetchFindByCity({}, city) {
      return await ptracGetEntities('streets/search/findByCitiesIn?cities=' + city)
    },
    async fetchByName({ state }, name) {
      const url = `streets/search/findOneByNameAndActive?name=${name}&active=true`
      const response = await ptracGetEntities(url)
      if (OK === response.status) {
        state.edit = response.data
      }
      return response
    }
  }
}
